import { render, staticRenderFns } from "./crjl.vue?vue&type=template&id=36eb9860&scoped=true&"
import script from "./crjl.vue?vue&type=script&lang=js&"
export * from "./crjl.vue?vue&type=script&lang=js&"
import style0 from "./crjl.vue?vue&type=style&index=0&id=36eb9860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb9860",
  null
  
)

export default component.exports